/**
 * Read-only visibility signal for the app's top-anchored notices (Part R
 * proposal revision 2, section 6.1). `TestimonyDraftNotice` reports whether it
 * is showing; `KeptRecordingNotice` stays hidden while it is, so the two never
 * overlap. Reporting changes nothing about the reporting notice itself.
 */
let testimonyDraftNoticeVisible = false;
const listeners = new Set<() => void>();

export function setTestimonyDraftNoticeVisible(visible: boolean): void {
  if (testimonyDraftNoticeVisible === visible) return;
  testimonyDraftNoticeVisible = visible;
  for (const listener of [...listeners]) {
    try {
      listener();
    } catch {
      // Observers only.
    }
  }
}

export function isTestimonyDraftNoticeVisible(): boolean {
  return testimonyDraftNoticeVisible;
}

export function subscribeTopNoticeVisibility(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
